<template>
  <f-dashboard-fullscreen-layout>
    <template #sidebar-header>
      <router-link 
        v-if="previousRoute"
        :to="previousRoute"
        @click.prevent="goBack"
      >
        <i class="uil uil-angle-left"></i> Fermer
      </router-link>
    </template>

    <template #sidebar-title>
      Ajouter un admin
    </template>

    <template #content-header>
      Informations

      <i class="uil uil-angle-right"></i> 
         
      Association
    </template>

    <template #content>
      <router-view 
        v-if="admin"
      ></router-view>
    </template>

    <template #content-footer>
      <f-button
        class="is-full"
        @click="createAdmin"
        fill 
      >
        Créer l'admin
      </f-button>
    </template>
  </f-dashboard-fullscreen-layout>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'

  export default {
    async setup () {
      const { get, patch } = useStore('@admin/users')

      const adminId = computed(() => router.currentRoute.value.params.id)
      const admin = computed(() => get(adminId.value))

      const previousRoute = {
        name: 'admins-list',
      }

      function goBack () {
        router.push({ path: previousRoute })
      }

      async function patchAdmin() {
        const data = {
          firstname: admin.value.firstname,
          lastname: admin.value.lastname,
          email: admin.value.email,
          password: admin.value.password,
          roles: [admin.value.roles],
        }
        try {
          return await patch(data)
        } catch (error) {
          console.log('ERROR', error)
        }
      }

      return {
        adminId,
        admin,
        previousRoute,
        goBack,
        patchAdmin,
      }
    } 
  }
</script>